import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import 'lazysizes';
import * as conditioner from 'conditioner-core/conditioner-core.min';
import * as locomotive from './modules/locomotive.js';
import * as cursor from './modules/cursor.js';
import * as dialog from './modules/dialog.js';
import { gsap } from "gsap";
import barba from '@barba/core';

// OneTrust Cookies Consent
ParamsData.oneTrust_id && import('./modules/onetrust').then(module => module.Onetrust());

// MarkerIo bugReports
ParamsData.bug_report_id && import('./modules/bugReport').then(module => module.bugReport());

cursor.init();

// ios viewport
const appHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

// on resize
var afterResize;
function afterResizeCallback(){
    gsap.to(document.body, { opacity: '1', duration: 0.25 });
    locomotive.update();
}

window.updateLocomotive = () => {
    locomotive.update();
}

if (window.matchMedia("(min-width: 768px)").matches) {
  window.onresize = function() {
      gsap.to(document.body, { opacity: '0', duration: 0.25 });
      clearTimeout(afterResize);
      afterResize = setTimeout(function() {
          afterResizeCallback();
      }, 300);
  };
}
const datalayer = () => {
    console.log("datalayer");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'dataLayer.ready'
    })
}
window.addEventListener("DOMContentLoaded", () => {

    // pages transitions
    barba.init({
        sync: true,
        transitions: [
            {
                async leave() {
                    gsap.to(document.body.querySelector('main'), { opacity: '0', duration: 0.5 });
                    const done = this.async();
                    await delay(500);
                    done();
                },
                enter() {
                    datalayer();
                },
                once() {
                    datalayer();
                    conditioner.hydrate(document.documentElement);
                    locomotive.init();
                    gsap.to(document.body, { opacity: '1', duration: 0.5 });
                }
            }
        ]
    });

    barba.hooks.after(() => {
        const main = document.querySelector('main');
        conditioner.hydrate(main);

        const modal_buttons = main.querySelectorAll('[aria-controls="dialog-rgpd"]');
        modal_buttons.forEach((modal_button) => {
            const el = document.querySelector(`#${modal_button.getAttribute('aria-controls')}`);
            if (el) {
                modal_button.addEventListener('click', () => {
                    dialog.toggle(el);
                })
            }
        });

        cursor.listeners();
        locomotive.reinit();

        if (window.stats == true) {
            ga('set', 'page', window.location.pathname);
            ga('send', 'pageview');

            var _paq = window._paq = window._paq || [];
            _paq.push(['setDocumentTitle', document.domain + "/" + document.title]);
            _paq.push(['trackPageView']);
        }
    });

    barba.hooks.leave((e) => {
        // reset masonry
        window.masonry = false;

        // menu links
        const menu_links = document.querySelectorAll('.menu-link');
        var next_path = new URL(e.next.url.href).pathname;

        menu_links.forEach((el) => {
            var path = new URL(el.href).pathname;
            if (path == next_path) {
                el.classList.add('active');
                return;
            }

            el.classList.remove('active');
        }); 
    });

    barba.hooks.enter(() => {        
        gsap.to(document.body.querySelector('main'), { opacity: '1', duration: 0.5 });
    })
});

function delay(n) {
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n)
    })
}

conditioner.addPlugin({
    monitor: {
        name: 'visible',
        create: (context, element) => ({
            matches: false,
            addListener(change) {
                new IntersectionObserver((entries) => {
                    this.matches = entries.pop().isIntersecting === context;
                    change();
                }).observe(element);
            },
        }),
    },
    moduleSetName: (name) => `./modules/${name}.js`,
    moduleGetConstructor: (module) => module.default,
    moduleImport: (name) => import( /* webpackMode: "lazy" */ `${name}`),
});

window.conditioner = conditioner;
// conditioner.hydrate(document.documentElement);

document.cookie = 'lonsdale=test-onetrust';